import AboutMeCard from "../about-me-card/about-me-card";
import ScrollAnimation from "react-animate-on-scroll";
import tomAllenbyPfp from "../../assets/Tom-Allenby.webp";
import adeleWaitesPfp from "../../assets/Adele-Waites.webp";
import teamImage from "../../assets/team.webp";
import "./about-me-module.css";

export default function AboutMe() {
  const teamMembersArr = [
    {
      name: "Tom Allenby",
      title:
        "BA (hons) Cardiff University, History & Italian. MA (Acting) Royal Birmingham Conservatoire.",
      photo: tomAllenbyPfp,
      blurb:
        "Tom is a professional actor and voice over artist, and a part time lecturer in Clinical Communication with University of Birmingham Medical School and Birmingham City University.\n\nTom can draw on his experience as an actor for stage, screen and audio to develop teachers’ vocal skill and confidence in and outside the classroom. His on-screen credits include Amazon Studios and Netflix; on stage, he has toured extensively across the UK and internationally; and in audio, he has worked with BBC Radio and narrated audiobooks for Audible.\n\nAt University of Birmingham Medical School and Birmingham City University, Tom teaches Clinical Communication at Undergraduate and Postgraduate levels, facilitating workshops on managing difficult conversations in the workplace with large group classes and one-to-one coaching.",
    },
    {
      name: "Adele Waites",
      title: "BA (hons) PGCE PG(dip) MA (Education).",
      photo: adeleWaitesPfp,
      blurb:
        "Adele is a professionally trained actor with over 15 years of experience in education and training. After graduating from Mountview Academy of Theatre Arts in 2004, she spent five years working as a professional actor, improvisational comedian, and voice coach before training as a Drama Teacher in 2009.\n\nAdele currently works at King Edward VI High School for Girls as a Drama Teacher, Head of Year Seven, and Lead Induction Tutor for Early Career Teachers. She leads regional training days for ECTs across the West Midlands and delivers national training online.\n\nWith a passion for developing others, Adele has mentored and trained teachers for over 15 years, delivering whole-school CPD, company workshops, and bespoke one-to-one coaching. Her approach combines instructional coaching with creativity and practical strategies for lasting impact. She is currently leading an action research project within her school, creating practical opportunities for students to build resilience and develop a growth mindset.",
    },
  ];

  return (
    <ScrollAnimation animateIn="fadeIn"animateOnce= {true}>
      <div className="ae-about-me-module-container">
        <h1 className="ae-about-me-title">
          Meet the ActEd. team
        </h1>
        <div className="ae-about-me-split-content">
          <img className="ae-about-me-image" src={teamImage} alt="" loading="eager"/>
          <div className="ae-about-me-split-content-text">
            <h2>Who are we?</h2>
            <p>
              Training and mentoring have always been our passion at ActEd. We
              firmly believe that <b>practice makes permanent</b> —whether it’s
              rehearsing difficult conversations, mastering effective vocal
              techniques, or applying confidence-building tips in the workplace. Our
              goal is to engage trainees in practical, hands-on learning that
              creates lasting, meaningful impact.
            </p>
            <p className="b">
              Our mission is giving professionals the vehicle and tools to develop their
              confidence and professional skills in the workplace.
            </p>
          </div>
        </div>
      </div>
      <div className="ae-team-info-container">
        {teamMembersArr.map((teamMember, index) => (
          <ScrollAnimation animateIn="fadeIn"animateOnce= {true}>
            <AboutMeCard
              name={teamMember.name}
              title={teamMember.title}
              photo={teamMember.photo}
              blurb={teamMember.blurb}
              index={index}
            />
          </ScrollAnimation>
        ))}
      </div>
    </ScrollAnimation>
  );
}
